import { Word as o, Paragraph as i } from "./components.js";
import { paragraphRecipe as a, wordRecipe as n } from "./recipes.js";
import { WordRenderSystem as p, WordMeasureSystem as l, ParagraphArrangeSystem as s } from "./systems.js";
import { setTextContent as c } from "./utils.js";
const f = {
  recipes: [a, n],
  systems: [p, l, s],
  components: {
    Paragraph: i,
    Word: o
  },
  config: {
    adapters: {
      word: {
        text: (t, e, r) => c(r, t, e)
      }
    },
    defaults: {
      paragraph: {
        gap: 0.2,
        align: 1,
        anchorX: 1,
        anchorY: 1,
        damping: 0
      },
      word: {
        fontSize: 1,
        color: 16777215,
        letterSpacing: 0,
        lineHeight: 1.2,
        outlineWidth: 0,
        outlineColor: 0,
        outlineBlur: 0,
        outlineOffsetX: 0,
        outlineOffsetY: 0,
        outlineOpacity: 1,
        strokeWidth: 0,
        strokeColor: 0,
        strokeOpacity: 1,
        fillOpacity: 1,
        curveRadius: 0,
        width: 0,
        dirty: 1
      }
    },
    enums: {
      paragraph: {
        align: {
          left: 0,
          center: 1,
          right: 2
        },
        anchorX: {
          left: 0,
          center: 1,
          right: 2
        },
        anchorY: {
          top: 0,
          middle: 1,
          bottom: 2
        }
      }
    }
  }
};
export {
  f as TextPlugin
};
//# sourceMappingURL=plugin.js.map
